"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyled = void 0;

var _utils = require("../../utils");

var _const = require("../../const");

var _const2 = require("./const");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var buttonSize = function buttonSize(measure, square) {
  return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    min-width: ", "px;\n    min-height: ", "px;\n    padding: ", "px\n      ", "px;\n    line-height: ", "px;\n  "])), _const2.ButtonSizeStyles[measure].height, _const2.ButtonSizeStyles[measure].height, _const2.ButtonSizeStyles[measure].paddingVertical, square ? _const2.ButtonSizeStyles[measure].paddingVertical : _const2.ButtonSizeStyles[measure].paddingHorizontal, _const2.ButtonSizeStyles[measure].lineHeight);
};

var buttonLink = (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  line-height: 16px;\n  padding: 0 !important;\n  box-shadow: none !important;\n  border: none;\n"])));
var buttonUnderlined = (0, _utils.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  line-height: 16px;\n  padding: 0 0 8px !important;\n  box-shadow: none !important;\n  position: relative;\n  border-bottom: 1px solid ", ";\n"])), _const.Colors.gray800);

var buttonVariation = function buttonVariation(variant, color) {
  return _const2.ButtonStates.map(function (item, index) {
    return (0, _utils.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", " {\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        svg {\n          fill: ", ";\n          display: inline-block;\n          vertical-align: ", ";\n          * {\n            fill: ", ";\n          }\n        }\n      }\n    "])), item, _const2.ButtonStyles[variant][color].bg[index], _const2.ButtonStyles[variant][color].color[index], _const2.ButtonStyles[variant][color].border[index], _const2.ButtonStyles[variant][color].color[index], variant == 'link' ? 'text-bottom' : 'middle', _const2.ButtonStyles[variant][color].color[index]);
  });
};

var ButtonStyled = (0, _utils.styled)('button')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: ", ";\n  display: inline-block;\n  border: 1px solid transparent;\n  ", ";\n  ", ";\n  ", ";\n  border-radius: 0;\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 11px;\n  letter-spacing: 1.65px;\n  text-transform: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  text-align: center;\n  appearance: none !important;\n  text-decoration: none;\n  ", "\n  ", "\n  &:disabled {\n    cursor: default;\n  }\n  ", "\n  ", "\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : 'auto';
}, function (_ref2) {
  var variant = _ref2.variant,
      $color = _ref2.$color;
  return buttonVariation(variant, $color);
}, function (_ref3) {
  var variant = _ref3.variant,
      measure = _ref3.measure,
      square = _ref3.square;
  return variant !== 'link' && variant !== 'underlined' ? buttonSize(measure, square) : buttonLink;
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'underlined' && buttonUnderlined;
}, _const.FontFamilyValue.primary, _const.FontWeightValue.bold, function (_ref5) {
  var uppercase = _ref5.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (_ref6) {
  var shade = _ref6.shade;
  return shade ? '0 1px 6px 0 #cfcde1' : 'none';
}, function (_ref7) {
  var fontWeight = _ref7.fontWeight;
  return fontWeight ? (0, _const.fontWeightHelperStyle)(fontWeight) : '';
}, function (_ref8) {
  var align = _ref8.align;
  return align ? (0, _const.alignHelperStyle)(align) : '';
}, function (_ref9) {
  var disabled = _ref9.disabled;
  return disabled && "pointer-events: none;";
}, function (props) {
  return (0, _const.spacingStyle)(props);
});
exports.ButtonStyled = ButtonStyled;